module.exports = __webpack_public_path__ + "img/error-page-dude.bcc53f5e.png";